export default function () {
    const parseFormErrors = (response) => {
        if (!response.data || (typeof response.data.reduce !== 'function')) {
            return [];
        }
        return response.data.reduce((original, error) => {
            original[error.field] = error.message;
            return original;
        }, {});
    };
    return { parseFormErrors };
}



// WEBPACK FOOTER //
// ./src/app/factories/error/handler/index.js